import { supabase } from "./supabaseClient";
import type { School } from "@/types/database";

export const TEXAS_CENTER: [number, number] = [31.9686, -99.9018];
export const TEXAS_DEFAULT_ZOOM = 6;

export async function fetchActiveSchools(): Promise<School[]> {
  const { data, error } = await supabase
    .from("schools")
    .select("*")
    .eq("pending", false)
    .order("name", { ascending: true });
  if (error) throw error;
  return (data ?? []) as School[];
}

export async function fetchAllSchools(): Promise<School[]> {
  const { data, error } = await supabase
    .from("schools")
    .select("*")
    .order("pending", { ascending: false })
    .order("name", { ascending: true });
  if (error) throw error;
  return (data ?? []) as School[];
}

/** Convenience client-side filter for the register-screen typeahead. */
export function filterSchools(schools: School[], q: string): School[] {
  const term = q.trim().toLowerCase();
  if (!term) return schools.slice(0, 50);
  return schools
    .filter(
      (s) =>
        s.name.toLowerCase().includes(term) ||
        (s.city ?? "").toLowerCase().includes(term) ||
        (s.county ?? "").toLowerCase().includes(term)
    )
    .slice(0, 50);
}
